<template>
	<!-- <div class="branch-container"> -->
	<div class="financial_management">
		<div class="finance_box">
			<header class="head"><span>财务管理</span></header>
			<div class="content_box">
				<div class="nav">
					<el-tabs v-model="activeName" @tab-click="handleClick">
						<el-tab-pane label="支付流水" name="0"></el-tab-pane>
						<el-tab-pane label="发票管理" name="1"></el-tab-pane>
					</el-tabs>
				</div>
				<div class="nav_content">
					<div class="content">
						<!-- 筛选 -->
						<div class="screen_box" v-show="activeName == '0'">
							<div class="list-item-time">
								<div class="text">付款时间:</div>
								<el-date-picker
									v-model="orderTime"
									type="daterange"
									format="yyyy-MM-dd"
									value-format="yyyy-MM-dd"
									range-separator="~"
									start-placeholder="开始日期"
									end-placeholder="结束日期"
									:picker-options="pickerOptions"
									@change="changeTime"
								>
								</el-date-picker>
							</div>
							<div class="list-item-search" @keyup.enter="checkOrder">
								<el-input
									placeholder="请输入项目名称、项目编号或设计师名称"
									v-model="searchValue"
									clearable
									@input="inputChange"
								>
								</el-input>
								<el-button type="danger" @click="checkOrder">查询</el-button>
							</div>
						</div>

						<div class="todo-pay" v-show="activeName == 0">
							<span>*</span> 温馨提示：使用微信支付的支付金额才能进行开具发票
						</div>

						<!-- 1 -->
						<div class="option_box" v-show="selected_order.length > 0">
							<div class="left">
								<div class="alert-clear">
									<i class="el-icon-info"></i>
									已选择<span class="">{{ selected_order.length }}</span
									>项
									<span class="clear" @click="closedDrawerClear()">清空</span>
								</div>
							</div>
							<div class="invoice_btn" v-if="activeName == '0'">
								<el-button type="danger" style="background: #e60000" @click="payDarwer(1)"
									>申请开票</el-button
								>
							</div>
							<div class="invoice_btn" v-if="activeName == '1'">
								<el-button type="danger" style="background: #e60000" @click="openTicket()"
									>下载发票</el-button
								>
							</div>
						</div>

						<div class="menu">
							<!-- 支付流水 -->
							<div class="pay_stream" v-show="activeName == '0'">
								<el-table
									ref="multipleTable0"
									tooltip-effect="dark"
									:data="pay_stream_data"
									style="width: 100%"
									max-height="645"
									:fit="true"
									@selection-change="handleSelectionChange1"
								>
									<el-table-column type="selection" width="50" :selectable="selected1">
									</el-table-column>

									<!-- pay_orderid -->
									<el-table-column prop="order_name" label="订单编号" min-width="100">
									</el-table-column>
									<el-table-column prop="order_pro_name" label="项目名称" min-width="150">
									</el-table-column>
									<!-- <el-table-column prop="base_creator_id" label="申请人">
                  </el-table-column> -->
									<el-table-column prop="pay_money" label="支付订单金额" min-width="116px">
										<template slot-scope="scope">
											<div class="pay_box">
												<!-- <span >{{scope.row.pay_amount}}</span> -->
												<span class="color-blue" v-if="scope.row.pay_money != '-'">{{
													scope.row.pay_money
												}}</span>
												<span v-else>{{ scope.row.pay_money }}</span>
											</div>
										</template>
									</el-table-column>
									<el-table-column prop="pay_amount" label="支付金额">
										<template slot-scope="scope">
											<div class="pay_box">
												<span>{{ scope.row.pay_amount }}</span>
											</div>
										</template>
									</el-table-column>
									<el-table-column prop="pay_score" label="支付积分">
										<template slot-scope="scope">
											<div class="pay_box">
												<span>{{ scope.row.pay_score }}</span>
											</div>
										</template>
									</el-table-column>
									<el-table-column prop="pay_price" label="支付余额">
										<template slot-scope="scope">
											<div class="pay_box">
												<span>{{ scope.row.pay_price }}</span>
											</div>
										</template>
									</el-table-column>

									<el-table-column label="订单状态">
										<template slot-scope="scope">
											<div :style="{ color: orderStatus2[scope.row.order_status] }">
												{{ scope.row.order_status }}
											</div>
										</template>
									</el-table-column>
									<!-- <el-table-column label="订单状态" :formatter="formatterClcik"></el-table-column> -->

									<el-table-column prop="order_design_id" label="设计师" width="120">
									</el-table-column>
									<!-- <div>{{scope.row.pay_tax_status}}</div> -->
									<!-- <el-table-column label="开票状态">
                    <template slot-scope="scope">
                      <div
                        :style="{
                          color: ticketStatus[scope.row.pay_tax_status].color,
                        }"
                      >
                        {{ ticketStatus[scope.row.pay_tax_status].txt }}
                      </div>

                    </template>
                  </el-table-column> -->
									<el-table-column
										prop="base_create_time"
										label="付款时间"
										min-width="150"
										sortable
									>
									</el-table-column>
									<el-table-column prop="pay_tax_time" label="开票时间" min-width="150" sortable>
									</el-table-column>
									<el-table-column label="操作" min-width="124" align="right">
										<template slot-scope="scope">
											<div
												class="operation"
												v-if="scope.row.is_button"
												@click="payDarwer(0, scope.row.id, scope.row.pay_orderid)"
											>
												<span>申请发票</span>
											</div>
										</template>
									</el-table-column>
								</el-table>
							</div>

							<!-- 发票管理 -->
							<div class="invoice" v-show="activeName == '1'">
								<el-table
									fixed
									ref="multipleTable1"
									tooltip-effect="dark"
									:data="tableData"
									style="width: 100%"
									max-height="645"
									@selection-change="handleSelectionChange2"
								>
									<el-table-column type="selection" width="50" :selectable="selected2">
									</el-table-column>

									<el-table-column prop="order_ids" label="订单编号" min-width="120">
										<template slot-scope="scope">
											<div class="order_ids" style="display: flex">
												<!-- <el-tooltip
                          effect="light"
                          :content="scope.row.order_ids"
                          placement="top"
                        > -->
												<p class="p1">{{ scope.row.order_ids }}</p>
												<span v-if="scope.row.num >= 2">共{{ scope.row.num }}项</span>
												<!-- </el-tooltip> -->
											</div>
										</template>
									</el-table-column>
									<el-table-column prop="order_names" label="项目名称" min-width="150">
										<template slot-scope="scope">
											<div class="order_names" style="display: flex">
												<!-- <el-tooltip
                          effect="light"
                          :content="scope.row.order_names"
                          placement="top"
                        > -->
												<p class="p1">{{ scope.row.order_names }}</p>
												<span v-if="scope.row.num >= 2">共{{ scope.row.num }}项</span>
												<!-- </el-tooltip> -->
											</div>
										</template>
									</el-table-column>
									<el-table-column prop="base_creator_name" label="申请人"> </el-table-column>
									<el-table-column prop="user_parice" label="开票金额"></el-table-column>
									<el-table-column label="订单状态">
										<template slot-scope="scope">
											<div>{{ scope.row.order_status }}</div>
										</template>
									</el-table-column>
									<el-table-column label="开票状态">
										<template slot-scope="scope">
											<div :style="'color:' + ticketStatus2[scope.row.user_tax_status || 0].color">
												{{ ticketStatus2[scope.row.user_tax_status || 0].txt }}
											</div>
										</template>
									</el-table-column>
									<!-- <el-table-column
                    prop="pay_time"
                    label="付款时间"
                    sortable
                    min-width="160"
                  >
                  </el-table-column> -->
									<el-table-column prop="user_check_time" label="开票时间" sortable min-width="150">
									</el-table-column>
									<el-table-column prop="operation" label="操作" min-width="124" align="right">
										<template slot-scope="scope">
											<div class="operation">
												<div class="download">
													<a
														@click="downloadInvoice(scope.row.id)"
														v-if="scope.row.download_invoice"
													>
														<span>下载发票</span>
													</a>
												</div>
												<div
													class="details"
													@click="drawerClick(scope.row.id, scope.row.user_tax_status)"
												>
													详情
												</div>
											</div>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</div>

						<!-- 分页 -->
						<div class="paging" v-show="showChenge()">
							<el-pagination
								background
								layout="prev, pager, next,sizes,jumper"
								:total="total"
								:current-page="currentPage"
								:page-size="pageSize"
								:page-sizes="[10, 20, 30]"
								@size-change="sizeChange"
								@current-change="currentChange"
							>
							</el-pagination>
						</div>

						<!-- 弹出框 -->
						<el-drawer title="申请开票" :with-header="false" :visible.sync="drawer" :size="800">
							<div class="drawer_box">
								<div class="drawer_title">
									<span>{{ drawer_title }}</span>
									<div class="shut" @click="drawer = false">
										<i class="el-icon-close"></i>
									</div>
								</div>

								<!--  申请失败                    -->
								<div class="alert_title error" v-if="user_tax_status == 5 && activeName == '1'">
									<i class="el-icon-error"></i>
									<span>开票失败</span>
									<div class="subtitle">{{ kp_info.refuse_content }}</div>
								</div>
								<!-- 申请中 -->
								<div class="alert_title" v-if="user_tax_status == 2 && activeName == '1'">
									<i class="el-icon-time"></i>
									<span>{{ ticketStatus[user_tax_status].txt }}，请您耐心等待</span>
								</div>

								<div class="drawer_main">
									<div class="apply_ticket" v-if="!complete">
										<!-- 申请开票信息 -->
										<div class="table_title">订单信息</div>
										<el-table :data="drawer_tableData" style="width: 100%">
											<!-- id -->
											<el-table-column prop="order_name" label="订单编号" width="130">
											</el-table-column>
											<el-table-column prop="order_pro_name" label="项目名称" width="150">
											</el-table-column>
											<el-table-column prop="base_create_time" label="付款时间" width="160">
											</el-table-column>
											<el-table-column prop="pay_score" label="支付积分"> </el-table-column>
											<el-table-column prop="pay_price" label="支付余额"> </el-table-column>
											<el-table-column prop="pay_amount" label="支付金额"> </el-table-column>
										</el-table>
										<el-row type="flex" :gutter="20" justify="end">
											<div class="sum">
												支付金额合计：<span>￥{{ sum }}</span>
											</div>
										</el-row>

										<!-- 支付流水 -- 填写发票信息 -->
										<div class="form_box" v-if="activeName == '0'">
											<div class="form_title">请填写发票信息</div>
											<el-form ref="form" :model="form" label-width="130px" :rules="rules">
												<el-form-item label="发票类型："> 增值税电子普通发票 </el-form-item>
												<el-form-item label="公司名称：" prop="company_name" required>
													<el-input v-model="form.company_name" maxlength="50"></el-input>
												</el-form-item>
												<el-form-item label="纳税人识别号：" prop="identifier" required>
													<el-input v-model="form.identifier" maxlength="30"></el-input>
												</el-form-item>
												<el-form-item label="收件邮箱：" prop="email" required>
													<el-input v-model="form.email" maxlength="30"></el-input>
												</el-form-item>

												<!-- 选填项 -->
												<div class="line"></div>
												<el-collapse v-model="activeNames" @change="handleChange">
													<el-collapse-item name="1">
														<template slot="title">
															<div class="form_sub_title">选填项</div>
														</template>
														<div class="form_sub_content">
															<el-form-item label="开户行：">
																<el-input v-model="form.bank" maxlength="50"></el-input>
															</el-form-item>
															<el-form-item label="银行账号：">
																<el-input v-model="form.bank_card" maxlength="30"></el-input>
															</el-form-item>
															<el-form-item label="联系电话：">
																<el-input v-model="form.mobile" maxlength="20"></el-input>
															</el-form-item>
															<el-form-item label="地址：">
																<el-input
																	type="textarea"
																	autosize
																	v-model="form.address"
																	maxlength="80"
																></el-input>
															</el-form-item>
														</div>
													</el-collapse-item>
												</el-collapse>

												<div class="line"></div>
												<el-row type="flex" :gutter="0" justify="end">
													<el-button class="btn_cancel" @click="drawer = false" size="small"
														>取消</el-button
													>
													<el-button
														class="btn_primary"
														type="primary"
														@click="onSubmit"
														size="small"
														>提交</el-button
													>
												</el-row>
												<div class="line"></div>
											</el-form>
										</div>

										<!-- 发票管理 -- 开票信息 -->
										<div class="kp_info" v-if="activeName == '1'">
											<el-row :gutter="24">
												<el-col :span="16">
													<div class="table_title">开票信息</div>
													<div class="kp_info_item">
														发票类型：{{
															kp_info.user_tax_type == 1 ? '增值税电子发票' : '增值税纸质发票'
														}}
													</div>
													<div class="kp_info_item"> 公司名称：{{ kp_info.user_name }} </div>
													<div class="kp_info_item"> 纳税人识别号：{{ kp_info.user_tax_no }} </div>
													<div class="kp_info_item"> 收件邮箱：{{ kp_info.user_mail }} </div>
													<div class="kp_info_item">
														开户行：{{ kp_info.user_open_back_name }}
													</div>
													<div class="kp_info_item">
														银行账号：{{ kp_info.user_company_card }}
													</div>
													<div class="kp_info_item"> 联系电话：{{ kp_info.user_phone }} </div>
													<div class="kp_info_item user_address">
														地址：{{ kp_info.user_post_address }}
													</div>
												</el-col>

												<!-- 发票详情 图片 PDF 显示 -->
												<el-col :span="8">
													<div class="kp_img">
														<!-- <img :src="kp_info.user_tax" alt="" width="100%" /> -->

														<!-- v-if="detail.invoice.suffix != 'pdf'" -->
														<img
															v-if="kp_info.tail != 'pdf'"
															:src="kp_info.user_tax"
															alt=""
															width="100%"
														/>
														<pdf ref="pdf" v-else :src="kp_info.user_tax" />
													</div>
												</el-col>
											</el-row>
											<el-row type="flex" justify="end">
												<el-button
													v-if="user_tax_status == 3"
													class="kp_btn"
													type="danger"
													size="small"
													@click="kp_downloadInvoice()"
													>下载发票</el-button
												>
											</el-row>
										</div>
									</div>

									<!-- 提交成功 -->
									<div class="get_complete" v-if="complete && SubmitState">
										<div class="left">
											<i class="el-icon-success"></i>
										</div>
										<div class="right">
											<el-row class="complete_item1">开票申请提交成功</el-row>
											<el-row class="complete_item2"
												>您的申请已提交，我们将在7个工作日内处理，请您耐心等待。</el-row
											>
										</div>
									</div>
									<el-button v-if="complete" class="btn" type="small" @click="getComplete()"
										>完成</el-button
									>
									<el-button
										class="btn"
										type="small"
										v-if="activeName == '1' && user_tax_status == 5"
										@click="resetApplication()"
										>重新申请</el-button
									>

									<!-- 提交失败 -->
									<div class="get_complete" v-if="complete && !SubmitState">
										<div class="left">
											<i class="el-icon-error"></i>
										</div>
										<div class="right">
											<el-row class="complete_item1">开票申请提交失败！</el-row>
										</div>
									</div>
								</div>
							</div>
						</el-drawer>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	/**
	 * $billList 发票管理列表
	 * $billDetails 发票详情
	 * $downloadInvoice 下载发票
	 * $paymentFlowLis 支付流水列表
	 * $applyInvoicing 支付流水-申请发票-内容
	 * $invoiceSubmit 支付流水-提交开票
	 * $getBill 默认开票信息
	 */
	import {
		$billList,
		$billDetails,
		$downloadInvoice,
		$paymentFlowLis,
		$applyInvoicing,
		$invoiceSubmit,
		$getBill,
	} from '@/api/index.js';
	import pdf from 'vue-pdf';
	export default {
		components: { pdf },
		data() {
			// 纳税人识别号 验证
			let identifierRules = (rule, value, callback) => {
				let reg = /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/;
				if (reg.test(value)) {
					let check = this.checkAddressCode(value.substring(0, 6));
					if (check) {
						return callback();
					}
					return callback(new Error('请输入正确的纳税人识别号'));
				} else {
					return callback(new Error('请输入正确的纳税人识别号'));
				}

				// if (!value) {
				//   return callback(new Error("请输入纳税人识别号"));
				// }
				// setTimeout(() => {
				//   let res = this.yz(value);
				//   if (res) {
				//     callback();
				//   } else {
				//     return callback(new Error("请输入正确的纳税人识别号"));
				//   }
				// }, 500);
			};

			// 手机号验证
			let phoneRule = (rule, value, callback) => {
				// if (value == "") return callback();
				// let regex = /^1[3456789]\d{9}$/
				// let regex = /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
				// if (regex.test(value)) {
				//   return callback();
				// } else {
				//   return callback("手机号错误");
				// }
				return callback();
			};
			return {
				activeName: '0',
				ticketStatus: {
					// 弹出框 订单状态
					0: { txt: '未开票', color: '#333' },
					1: { txt: '申请中', color: '#1890FF' },
					2: { txt: '开票中', color: '#1890FF' },
					3: { txt: '已开票', color: '#12B142' },
					4: { txt: '已过期', color: '#12B142' },
				},
				ticketStatus2: {
					// 发票管理
					1: { txt: '未开票', color: '#333333' },
					2: { txt: '开票中', color: '#1890FF' }, // 待开票
					3: { txt: '已开票', color: '#12B142' },
					4: { txt: '已过期', color: '#999999' },
					5: { txt: '开票失败', color: '#e60000' },
				},

				// orderStatus:{'设计中': '#1890FF', '待审核': '#1890FF', '已验收': '#12B142', '已完成': '#12B142'},
				orderStatus2: {
					已完成: '#12B142',
					已验收: '#12B142',
					待修改: '#1890FF',
					待验收: '#1890FF',
					设计中: '#1890FF',
				},
				user_tax_status: 1, // 开票状态
				selected_order: [], // 选中的表单数据

				pay_stream_data: [], // 支付流水
				tableData: [], // 发票列表

				total: 0, // 总条数
				currentPage: 1, // 当前页数
				pageSize: 10, // 每页显示条数

				drawer: false, // 弹出框状态
				drawer_title: '开票申请',
				bill_id: null, // 发票详情id
				drawer_tableData: [], // 弹框开票信息
				order_ids2: [], //选中的id
				order_ids_total: '', // 选择 合计 提交 时 字符串id
				form: {
					company_name: '', // 公司名称
					identifier: '', // 纳税人识别号
					email: '', // 邮箱
					bank: '', // 开户行
					bank_card: '', // 银行账号
					mobile: '', // 联系电话
					address: '', // 地址
				}, // 支付流水 -- 填写发票信息

				rules: {
					company_name: [
						{
							required: true,
							message: '请输入公司名称',
							trigger: ['blur', 'change'],
						},
						// { min: 1, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
					],
					identifier: [
						{
							required: true,
							message: '请输入纳税人识别号',
							trigger: ['blur', 'change'],
						},
						{ validator: identifierRules, trigger: ['blur', 'change'] },
					],
					email: [
						{
							required: true,
							message: '请输入邮箱地址',
							trigger: ['blur', 'change'],
						},
						{
							type: 'email',
							message: '请输入正确的邮箱地址',
							trigger: ['blur', 'change'],
						},
					],
					bank: [],
					bank_card: [],
					mobile: [{ validator: phoneRule, trigger: ['blur', 'change'] }],
					address: [],
				}, // 表单验证规则

				activeNames: ['1'],

				sum: 0,
				kp_info: {}, // 弹窗发票数据
				downloadImgName: '发票',

				complete: false, //
				SubmitState: true, // 提交状态
				kp_downloadInvoice_stade: true, // 下载发票状态

				// 筛选
				orderTime: [], // 时间
				searchValue: '', // 搜索框
				pickerOptions: {
					disabledDate(time) {
						//只能选择今天及今天之前的日期
						return time.getTime() > Date.now();
						//只能选择今天及今天之后的日期
						//return time.getTime() < Date.now() - 8.64e6; //只能选择今天之后的日期，今天的日期也不能选
					},
				},
			};
		},
		created() {
			if (this.activeName == '0') {
				this.paymentFlowLis(); // 支付流水列表
			} else {
				this.getBillList(); // 发票列表
			}
		},
		mounted() {
			this.getBillInvoiceInfo();
		},
		methods: {
			// 重新申请
			resetApplication() {
				// num, id, order_ids
				this.drawer = true;
				this.activeName = '0';
				this.applyInvoicing(
					this.kp_info.user_tax_bind,
					this.drawer_tableData.map((item) => item.id).join(',')
				);
			},
			// 筛选搜索
			checkOrder() {
				let time = this.orderTime;
				let value = this.searchValue;
				this.paymentFlowLis(
					String(this.pageSize),
					'1',
					time && time.length > 0 ? time.join(',').replace(',', '~') : '',
					value
				);
				// console.log("时间：" + time, "值：" + value);
			},
			inputChange(value) {
				// 输入事件
				if (value == '') {
					this.checkOrder();
				}
			},
			changeTime(ev) {
				// 日期筛选
				// console.log("日期", ev);
			},

			// 支付流水 多选框状态
			selected1(row, index) {
				if (row.is_button == 1) {
					return true; // 可勾选
				} else {
					return false; // 不可勾选
				}
			},
			// 发票管理 多选框状态
			selected2(row, index) {
				if (row.download_invoice == 1) {
					return true; // 可勾选
				} else {
					return false; // 不可勾选
				}
			},
			// 获取 默认开票信息
			getBillInvoiceInfo() {
				$getBill({}).then((res) => {
					if (res) {
						//   form: {
						//   identifier: "",
						//   company_name: "",
						//   email: "",
						//   bank: "",
						//   bank_card: "",
						//   mobile: "",
						//   address: "",
						// }, // 支付流水 -- 填写发票信息

						if (res.data.company_name) {
							this.form.company_name = res.data.company_name;
						}
						if (res.data.identifier) {
							this.form.identifier = res.data.identifier;
						}
						if (res.data.email) {
							this.form.email = res.data.email;
						}
						if (res.data.bank) {
							this.form.bank = res.data.bank;
						}
						if (res.data.bank_card) {
							this.form.bank_card = res.data.bank_card;
						}
						if (res.data.mobile) {
							this.form.mobile = res.data.mobile;
						}
						if (res.data.address) {
							this.form.address = res.data.address;
						}
					}
				});
			},

			// 获取发票列表
			getBillList(pagesize = 10, current_page = 1) {
				let params = {
					rows: pagesize,
					page: current_page,
				};
				$billList(params)
					.then((res) => {
						// console.log("获取发票列表", res);
						this.tableData = res.data.rows;

						this.tableData.map((item, index) => {
							item.user_parice = item.user_parice ? '￥' + item.user_parice : '-';
							item.user_check_time = item.user_check_time ? item.user_check_time : '-';
							item.num = item.order_ids.split('/').length;
						});

						this.total = res.data.total.total; // 总条数
						this.currentPage = res.data.total.current_page; // 当前页
					})
					.catch((err) => {
						console.log(err);
					});
			},

			// 获取发票详情
			billDetails(bill_id) {
				$billDetails({ bill_id })
					.then((res) => {
						// console.log('发票详情', res);

						this.drawer_tableData = res.data.order_list;

						this.drawer_tableData.map((item) => {
							item.pay_score = item.pay_score ? item.pay_score : '-';
							item.pay_price = '￥' + this.decimalFliter(item.pay_price);
							item.pay_amount = item.pay_amount ? '￥' + this.decimalFliter(item.pay_amount) : '-';
						});
						this.sum = res.data.total_amount; // 合计
						this.kp_info = res.data.data; // 开票信息
					})
					.catch((err) => {
						console.log(err);
					});
			},
			decimalFliter(params) {
				// 保留2位小数
				let index = params.indexOf('.');
				if (index == -1) return params + '.00';
				return params.slice(0, index + 3);
			},

			// 下载发票
			downloadInvoice(bill_id, state) {
				$downloadInvoice({ bill_id })
					.then((res) => {
						// console.log('下载发票链接', res);

						window.location.href = res.data; // 下载发票

						if (state) return;
						setTimeout(() => {
							this.kp_downloadInvoice_stade = true;
						}, 1000);
					})
					.catch((err) => {
						console.log(err);
					});
			},

			// 获取支付流水列表
			paymentFlowLis(pagesize = 10, current_page = 1, time, value) {
				let params = {
					rows: pagesize,
					page: current_page,
					pay_time: time ? time : '',
					search: value ? value : '',
				};

				$paymentFlowLis(params)
					.then((res) => {
						// console.log('支付流水列表', res);
						this.total = res.data.total.total;
						this.currentPage = res.data.total.current_page;

						this.pay_stream_data = res.data.rows;
						this.pay_stream_data.map((item) => {
							item.pay_money = Number(item.pay_money) ? '￥' + item.pay_money : '-';
							item.pay_amount = Number(item.pay_amount) ? '￥' + item.pay_amount : '-';
							item.pay_score = Number(item.pay_score) ? item.pay_score : '-';
							item.pay_price = Number(item.pay_price) ? '￥' + item.pay_price : '-';
						});
					})
					.catch((err) => {
						console.log(err);
					});
			},

			// 支付流水-申请发票-内容 详情
			applyInvoicing(id, order_ids) {
				// console.log(id, order_ids);
				this.order_ids_total = order_ids;
				this.complete = false;
				this.drawer = true;
				let params = { id, order_ids };
				$applyInvoicing(params)
					.then((res) => {
						// console.log('申请发票-内容', res);

						this.sum = res.pay_amount_total; // 合计
						this.drawer_tableData = res.data.rows;

						// let num = res.data.rows[0].pay_score;

						this.drawer_tableData.map((item) => {
							item.pay_score = item.pay_score ? this.decimalFliter(item.pay_score) : '-';
							item.pay_price = '￥' + this.decimalFliter(item.pay_price);
							item.pay_amount = item.pay_amount ? '￥' + item.pay_amount : '-';
						});
						this.order_ids2 = res.data.pay_log_id;
						this.sum = res.data.pay_amount_total; // 合计
						if (res.data.userBillList) {
							this.form = res.data.userBillList; // 填写发票信息
						}
					})
					.catch((err) => {
						console.log(err);
					});
			},

			// 支付流水-提交开票
			invoiceSubmit(params) {
				$invoiceSubmit(params)
					.then((res) => {
						// console.log('提交开票', res);
						if (res.data) {
							this.drawer_title = '提交成功';
							this.complete = true;
							this.SubmitState = true;
						} else {
							this.drawer_title = '提交失败';
							this.complete = true;
							this.SubmitState = false;
						}
					})
					.catch((err) => {
						console.log(err);
					});
			},

			// 分类导航
			handleClick(tab, event) {
				this.pageSize = 10;
				this.selected_order = [];
				if (tab.name == '0') {
					this.paymentFlowLis();
				} else if (tab.name == '1') {
					this.getBillList();
				}
			},

			// 清空
			closedDrawerClear(rows) {
				if (rows) {
					rows.forEach((row) => {
						this.activeName == '0'
							? this.$refs.multipleTable0.toggleRowSelection(row)
							: this.$refs.multipleTable1.toggleRowSelection(row);
					});
				} else {
					this.activeName == '0'
						? this.$refs.multipleTable0.clearSelection()
						: this.$refs.multipleTable1.clearSelection();
				}
			},
			// 选中
			handleSelectionChange1(val) {
				this.selected_order = val;
			},
			handleSelectionChange2(val) {
				this.selected_order = val;
			},

			// 每页条数改变触发
			sizeChange(pageSize) {
				this.pageSize = pageSize;
				if (this.activeName == '0') {
					this.paymentFlowLis(
						String(this.pageSize),
						String(this.currentPage),
						this.orderTime && this.orderTime.length > 0
							? this.orderTime.join(',').replace(',', '~')
							: '',
						this.searchValue
					);
				} else if (this.activeName == '1') {
					this.getBillList(String(this.pageSize), String(this.currentPage));
				}
			},
			// 页码改变触发
			currentChange(currentPage) {
				this.currentPage = currentPage;
				if (this.activeName == '0') {
					this.paymentFlowLis(
						String(this.pageSize),
						String(this.currentPage),
						this.orderTime && this.orderTime.length > 0
							? this.orderTime.join(',').replace(',', '~')
							: '',
						this.searchValue
					);
				} else if (this.activeName == '1') {
					this.getBillList(String(this.pageSize), String(this.currentPage));
				}
			},

			// 支付流水 -- 多选开票
			payDarwer(num, id, order_ids) {
				this.drawer_title = '申请开票';
				let ids = [];
				let order_ids2 = [];
				if (num) {
					this.selected_order.forEach((item, index) => {
						// if (item.download_invoice) {
						if (item.is_button) {
							ids.push(item.id);
							order_ids2.push(item.pay_orderid);
						}
					});

					id = ids.join(',');
					this.order_ids2 = ids.join(',');
					order_ids = order_ids2.join(',');

					if (ids.length) {
						this.drawer = true;
						this.applyInvoicing(id, order_ids);
						return;
					}
					// this.open4();
					return;
				}
				// console.log(id, order_ids);
				this.applyInvoicing(id, order_ids);
			},

			// 点击 发票详情
			drawerClick(bill_id, user_tax_status) {
				this.drawer = true;
				this.drawer_title = '开票详情';
				this.user_tax_status = user_tax_status;
				this.bill_id = bill_id;
				this.billDetails(bill_id);

				return;

				// let pay_sum = 0;
				// this.drawer_tableData = data.order_list;
				// this.drawer_tableData.map(item => {
				//   item.pay_score = item.pay_score?item.pay_score:'-';
				//   pay_sum += Number(item.pay_price);
				//   item.pay_price = '￥' + item.pay_price;
				//   item.pay_amount = item.pay_amount?'￥' + item.pay_amount:'-';
				// })
				// this.sum = pay_sum; // 合计

				// this.kp_info = data.data; // 开票信息

				// console.log(this.drawer_tableData);
			},

			//  下载发票
			kp_downloadInvoice(id) {
				// console.log('下载发票id', id);
				let bill_id = id || this.bill_id;

				if (this.kp_downloadInvoice_stade) {
					this.kp_downloadInvoice_stade = false;

					this.downloadInvoice(bill_id);
				}
			},
			// 多选 -- 下载发票
			openTicket() {
				let ids = [];
				this.selected_order.forEach((item) => {
					if (item.download_invoice) {
						ids.push(item.id);
					}
				});
				// ids = ids.length>1?ids.join(','):ids[0];
				// console.log('筛选数据：', ids);

				for (let i = 0; i < ids.length; i++) {
					this.downloadInvoice(ids[i], true);
				}
			},

			// 选填框
			handleChange(val) {
				// console.log(val);
			},

			// 支付流水 提交表单
			onSubmit() {
				this.$refs['form'].validate((valid) => {
					if (valid) {
						let form = this.form;

						// let ids = this.drawer_tableData.map((item, index) => {
						//   return item.id;
						// });
						// console.log(this.drawer_tableData, "ids");
						// ids = ids.join(",");
						let params = {
							user_tax_bind: this.order_ids2,
							user_name: form.company_name,
							user_tax_no: form.identifier,
							user_mail: form.email,
							user_open_back_name: form.bank,
							user_company_card: form.bank_card,
							user_phone: form.mobile,
							user_post_address: form.address,
						};
						params.order_ids = this.order_ids_total;
						// console.log('表单提交----------', params);
						this.invoiceSubmit(params);

						// setTimeout(() => {
						//   this.paymentFlowLis(this.pageSize, this.currentPage); // 刷新 支付流水 数据列表
						// }, 200);
					} else {
						return false;
					}
				});
			},

			// 完成
			getComplete() {
				this.drawer = false;
				this.complete = false;
				this.paymentFlowLis();
			},

			// 是否显示分页
			showChenge() {
				let name = this.activeName;
				if (name == '0') {
					if (this.pay_stream_data.length) return true;
					return false;
				}

				if (name == '1') {
					if (this.tableData.length) return true;
					return false;
				}
			},

			// 验证 纳税人识别号
			yz(taxpayerId) {
				let addressCode = taxpayerId.substring(0, 6);
				// 校验地址码
				let check = this.checkAddressCode(addressCode);
				if (!check) {
					// alert("请输入正确的纳税人识别号 (地址码)！");
					return false;
				} else {
					// 校验组织机构代码
					let orgCode = taxpayerId.substring(6, 9);
					check = this.orgcodevalidate(orgCode);
					if (!check) {
						// alert("请输入正确的纳税人识别号(组织机构代码) ！");
						return false;
					}
				}

				return true;
			},
			// 校验组织机构代码
			orgcodevalidate(value) {
				if (value != '') {
					let part1 = value.substring(0, 8);
					let part2 = value.substring(value.length - 1, 1);
					let ws = [3, 7, 9, 10, 5, 8, 4, 2];
					let str = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
					let reg = /^([0-9A-Z]){8}$/;
					if (!reg.test(part1)) {
						return true;
					}
					let sum = 0;
					for (let i = 0; i < 8; i++) {
						sum += str.indexOf(part1.charAt(i)) * ws[i];
					}
					let C9 = 11 - (sum % 11);
					let YC9 = part2 + '';
					if (C9 == 11) {
						C9 = '0';
					} else if (C9 == 10) {
						C9 = 'X';
					} else {
						C9 = C9 + '';
					}
					return YC9 != C9;
				}
			},
			// 校验地址码
			checkAddressCode(addressCode) {
				let provinceAndCitys = {
					11: '北京',
					12: '天津',
					13: '河北',
					14: '山西',
					15: '内蒙古',
					21: '辽宁',
					22: '吉林',
					23: '黑龙江',
					31: '上海',
					32: '江苏',
					33: '浙江',
					34: '安徽',
					35: '福建',
					36: '江西',
					37: '山东',
					41: '河南',
					42: '湖北',
					43: '湖南',
					44: '广东',
					45: '广西',
					46: '海南',
					50: '重庆',
					51: '四川',
					52: '贵州',
					53: '云南',
					54: '西藏',
					61: '陕西',
					62: '甘肃',
					63: '青海',
					64: '宁夏',
					65: '新疆',
					71: '台湾',
					81: '香港',
					82: '澳门',
					91: '国外',
				};
				let check = /^[1-9]\d{5}$/.test(addressCode);
				if (!check) return false;
				if (provinceAndCitys[parseInt(addressCode.substring(0, 2))]) {
					return true;
				} else {
					return false;
				}
			},

			// 提示弹窗
			open4() {
				this.$message.error({
					message: '没有可以申请发票的订单了！',
					showClose: true,
				});
			},
		},
		computed: {},
		filters: {
			// filterNumber(val) {
			//   if(val == '-') return '-';
			//   val = String((Math.floor(val * 100) / 100))
			//   console.log('过滤器', val);
			//   return val;
			// }
			// userTaxStatus(num) {
			//   let str = ''
			//   // 1=申请中,2=开票中,3=已开票,4=已拒绝
			//   switch (num) {
			//     case 1:
			//       str = `<span style="color: #1890FF;font-size: 14px">申请中</span>`
			//       break;
			//     case 2:
			//       str = `<span style="color: #1890FF;font-size: 14px">开票中</span>`
			//       break;
			//     case 3:
			//       str = `<span style="color: #12B142;font-size: 14px">已开票</span>`
			//       break;
			//     case 4:
			//       str = `<span style="color: #12B142;font-size: 14px">已过期</span>`
			//       break;
			//     default:
			//       break;
			//   }
			//   console.log(str);
			//   return str;
			// }
		},
		watch: {
			drawer(row, col) {
				if (!row) {
					// this.complete = false;
					this.kp_info = {};
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.financial_management {
		height: 100%;
		.head {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 64px;
			padding: 18px 24px;
			box-sizing: border-box;
			background: #ffffff;
			font-size: 20px;
			font-weight: Bold;
			color: rgba(0, 0, 0, 0.85);
		}
		.finance_box {
			position: relative;
			width: 100%;
			height: 100%;
			min-height: 775px;
			padding: 24px;
			padding-bottom: 4px;
			padding-top: calc(64px + 24px);
			box-sizing: center;
			background: #f0f2f5;
			.content_box {
				width: 100%;
				height: 100%;
				background: #ffffff;
				border-radius: 2px;
			}
		}
	}

	.nav {
		width: 100%;
		// height: 52px;
		background: #ffffff;
		padding: 15px 24px 0;
		box-sizing: border-box;
	}
	::v-deep {
		.el-tabs__item {
			font-size: 16px;
		}
		.el-tabs__item:hover {
			color: #e60000;
		}
		.el-tabs__item.is-active {
			color: #e60000;
		}
		.el-tabs__active-bar {
			background: #e60000;
		}
	}
	.active {
		position: relative;
		span {
			color: #e60000;
		}
		&::before {
			content: '';
			position: absolute;
			bottom: -16px;
			left: 50%;
			transform: translateX(-50%);
			width: 48px;
			height: 2px;
			background: #e60000;
		}
	}
	.nav_content {
		width: 100%;
		max-height: calc(100% - 69px);
		background: #ffffff;
		padding: 24px;
		padding-top: 0;
		box-sizing: border-box;
		.content {
			width: 100%;
			overflow: hidden;
			.screen_box {
				// 筛选
				min-width: 960px;
				display: flex;
				flex-wrap: wrap;
				.list-item-time {
					display: flex;
					margin-right: 48px;
					align-items: center;
					.text {
						font-size: 16px;

						font-weight: 400;
						line-height: 22px;
						color: #333333;
						opacity: 1;
						margin-right: 12px;
					}
				}
				.list-item-search {
					display: flex;
					button {
						margin-left: 10px;
						background: $theme-color;
					}
				}
			}
			.option_box {
				width: 100%;
				height: 40px;
				font-size: 14px;
				border-radius: 2px;
				overflow: hidden;
				display: flex;
				justify-content: space-between;
				.left {
					width: 100%;
					margin-right: 24px;
					.alert-clear {
						display: flex;
						align-items: center;
						box-sizing: border-box;
						margin-bottom: 10px;
						padding: 0px 16px;
						width: 100%;
						height: 40px;
						background: rgba(230, 50, 65, 0.02);
						border-radius: 2px;
						border: 1px solid #e60000;
						font-size: 14px;

						font-weight: 400;
						line-height: 22px;
						color: rgba(0, 0, 0, 0.65);

						span,
						i {
							color: #e60000;
						}
						i {
							margin-right: 8px;
						}
						span {
							margin: 0px 4px;
						}
						.clear {
							cursor: pointer;
							margin-left: 10px;
						}
					}
				}
			}
		}
	}

	.el-table .warning-row {
		background: oldlace;
	}
	.el-table .success-row {
		background: #f0f9eb;
	}

	.menu {
		width: 100%;
		// max-height: calc(100% - 48px);
		margin-bottom: 18px;
		overflow: hidden;
		.operation {
			display: flex;
			justify-content: flex-end;
			color: #e60000;
			font-size: 14px;
			.download {
				width: 56px;
				margin-right: 17px;
			}
			span {
				color: #e60000;
				font-weight: 400;
				cursor: pointer;
			}
			.details {
				width: 30px;
				cursor: pointer;
			}
		}
	}

	// 分页
	.paging {
		margin-right: 24px;
		display: flex;
		justify-content: flex-end;
		background: #fff;
		// padding: 0px 24px 5px;
		// box-sizing: content-box;
		// width: 100%;
		// margin-left: -24px;
		.item {
			color: #e60000;
		}
	}
	// .pagings {
	//   position: absolute;
	//   bottom: 0px;
	//   right: 32px;
	// }

	// 分页
	::v-deep {
		.el-pagination {
			display: flex;
		}
		.el-pagination.is-background .el-pager li:not(.disabled) {
			background-color: #fff;
			border: 1px solid #d9d9d9;
			color: rgba(0, 0, 0, 0.65);
		}
		.el-pagination.is-background .el-pager li:not(.disabled).active {
			background-color: #e60000;
			color: #ffffff;
		}
		.el-select-dropdown__item .selected {
			color: #e60000;
		}
		.btn-prev,
		.btn-next {
			border: 1px solid #d9d9d9;
			background-color: #fff !important;
		}
	}

	// 弹出框
	.drawer_title {
		width: 100%;
		height: 54px;
		padding: 16px 0 16px 32px;
		border-bottom: 1px solid #e9e9e9;
		font-size: 16px;
		display: flex;
		justify-content: space-between;
		align-items: content;
		.shut {
			line-height: 21px;
			margin-right: 32px;
			cursor: pointer;
		}
		span {
			color: #000000;
			font-weight: bold;
		}
	}
	.alert_title.error {
		position: relative;
		padding: 13px 32px 12px 32px;
		align-items: flex-start;
		height: 80px;
		.subtitle {
			position: absolute;
			bottom: 12px;
			left: 68px;
			font-size: 14px;
			font-weight: 400;
			line-height: 22px;
			color: #333333;
		}
	}
	.alert_title {
		width: 100%;
		height: 48px;
		padding-left: 32px;
		background: rgba(230, 50, 65, 0.1);
		color: #333333;
		font-size: 16px;
		font-weight: bold;
		display: flex;
		align-items: center;
		i {
			margin-right: 12px;
			font-size: 24px;
			color: #e60000;
		}
	}
	.drawer_main {
		width: 100%;
		padding: 32px 29px;
		.table_title {
			width: 100%;
			color: #666666;
			font-size: 16px;
			font-weight: bold;
			margin-bottom: 20px;
		}
		.sum {
			margin-top: 20px;
			margin-bottom: 32px;
			margin-right: 10px;
			color: #333333;
			font-size: 14px;
			span {
				color: #e60000;
				font-size: 20px;
				font-weight: 600;
			}
		}
		.btn_cancel:hover {
			color: #333333;
			background: #fff;
		}
		.btn_primary {
			background: #e60000;
			border: none;
			&:hover {
				background: #e92535;
			}
		}

		.kp_info {
			color: #333333;
			font-size: 14px;
			.kp_info_item {
				margin: 16px 0;
			}
			.user_address {
				min-height: 40px;
			}
			.kp_img {
				width: 100%;
				// height: 100px;
				margin-top: calc(21px + 8px);
			}
			.kp_btn {
				margin-top: 30px;
				font-size: 14px;
				color: #ffffff;
				background: #e60000;
				&:hover {
					background: #e52636;
				}
			}
		}
		.btn {
			position: absolute;
			bottom: 11px;
			right: 32px;
			color: #fff;
			background: #e60000;
			&:hover {
				background: #e92a3a;
			}
		}
	}

	// 表单
	.form_title,
	.form_sub_title {
		color: #666666;
		font-size: 16px;
		font-weight: bold;
	}
	.line {
		margin-top: 12px;
	}
	.el-form-item {
		margin-bottom: 20px;
	}
	.el-input {
		width: 400px;
	}
	::v-deep {
		.el-textarea {
			width: 400px;
			.el-textarea__inner {
				// min-height: 40px !important;
				// padding-top: 10px;
			}
		}
	}

	.get_complete {
		display: flex;
		align-items: center;
		.left {
			margin-right: 24px;
			.el-icon-success {
				color: #12b142;
				font-size: 48px;
			}
		}
		.complete_item1 {
			color: #333333;
			font-size: 20px;
			font-weight: bold;
		}
		.complete_item2 {
			color: #333333;
			font-size: 16px;
		}
	}

	.p1 {
		flex: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	::v-deep {
		.el-checkbox__input.is-checked .el-checkbox__inner,
		.el-checkbox__input.is-indeterminate .el-checkbox__inner {
			background-color: #e60000;
			border-color: #e60000;
		}
		.el-select-dropdown__item.selected {
			color: #e60000;
			font-weight: 700;
		}
		.el-table__row {
			height: 58px;
		}
	}
	// .el-button {
	//   background: #e60000;
	// }

	// 必填框 提示符
	::v-deep .el-form-item__label::before {
		content: '' !important;
		margin-right: 0px;
	}
	::v-deep .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
		content: '*';
		color: #f56c6c;
		margin-left: 6px;
	}

	::v-deep {
		.color-blue {
			color: #1890ff !important;
		}
	}

	// 日期输入框
	::v-deep {
		.el-range-editor.is-active,
		.el-range-editor.is-active:hover {
			border-color: $theme-color;
		}

		// 输入框边框颜色
		// .el-input__inner:hover {
		//   border-color: $theme-color;
		// }
		.el-input__inner:focus {
			border-color: $theme-color;
		}
		// .pay_box {
		//   text-align: right;
		// }
	}
	.todo-pay {
		margin: 14px 0px;
		font-size: 16px;
		font-weight: 400;
		line-height: 22px;
		color: #999999;
		span {
			font-size: 16px;
			font-weight: 400;
			line-height: 22px;
			color: #e60000;
		}
	}
</style>
